// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1bcc5225","453":"842c90a1","455":"52d6f106","977":"a03c01e8"}[chunkId] + ".chunk.js";
};